import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import DropdownOption from "interfaces/DrowpdownOption";

export enum ESurfacesNames {
  DIRT = "Dirt",
  TURF = "Turf",
  UNKNOWN = "unknown"
}

export const surfaces = [
  "Any",
  "Synthetic",
  "Turf",
  "Steeplechase",
  "Inner track",
  "Outer turf",
  "Wood chips",
  "Hunt on turf",
  "Timber",
  "Dirt",
  "Turf training",
  "Jump",
  "All weather training",
  "Hunt",
  "Downhill turf",
  "Dirt training",
  "Inner turf",
  "Hurdle"
];

export const ages: DropdownOption[] = [
  { value: "", label: "Any" },
  { value: racehorse360.HorseAge.HORSE_AGE_TWO.toString(), label: "2" },
  { value: racehorse360.HorseAge.HORSE_AGE_THREE.toString(), label: "3" },
  { value: racehorse360.HorseAge.HORSE_AGE_THREE_PLUS.toString(), label: "3+" },
  { value: racehorse360.HorseAge.HORSE_AGE_FOUR.toString(), label: "4" },
  { value: racehorse360.HorseAge.HORSE_AGE_FOUR_PLUS.toString(), label: "4+" }
];

export const gendersGroups = [
  [],
  [0, 2, 3, 5, 7], //"Colt", "Gelding", "Horse", "Ridgling", "Invalid"
  [1, 4, 6] //"Spayed Mare", "Filly", "Mare"
];

export const genderSelectContent = ["Any", "Colt/Horse", "Filly/Mare"];

export const distances = ["Any", "Short", "Long"];

export const conditions = [
  "Any",
  "MVL",
  "MSW",
  "NXT",
  "N2",
  "N2X",
  "N3",
  "N3X",
  "AOC",
  "ALW"
];

export const getSurfaceName = (
  type: racehorse360.CourseSurface
): ESurfacesNames => {
  const { COURSE_SURFACE_DIRT, COURSE_SURFACE_TURF } =
    racehorse360.CourseSurface;

  switch (type) {
    case COURSE_SURFACE_DIRT:
      return ESurfacesNames.DIRT;
    case COURSE_SURFACE_TURF:
      return ESurfacesNames.TURF;
    default:
      return ESurfacesNames.UNKNOWN;
  }
};
